import system from 'durandal/system.js';
import featureFlags from '@cheqroom/web/src/services/feature-flags';

var hubspot = {
	chatToken: '',
	authUser: null,
	global: null,
	hasChatToken: false,
	tokenExpiresAt: 0,
};

hubspot.init = function (spec = {}) {
	hubspot.global = spec.global;
	hubspot.authUser = spec.authUser;
	hubspot.global.storageHandler.load(hubspot);
};

hubspot.isEnabled = () => {
	return process.env.HUBSPOT_ID;
};

hubspot._getFullId = function () {
	return 'app.hubspot';
};

hubspot.addTrackingCode = () => {
	const script = document.createElement('script');
	script.innerHTML = `
		var d = document;
					var w = window;
					var hs = d.createElement('script');
					hs.type = 'text/javascript';
					hs.async = true;
					hs.defer = true;
					hs.src = (document.location.protocol === 'https:' ? 'https://' : 'http://') +
					'js.hs-scripts.com/${process.env.HUBSPOT_ID}.js';
					var s = d.getElementsByTagName('script')[0];
					s.parentNode.insertBefore(hs, s);
	`;
	document.head.appendChild(script);
};

hubspot._toStorageData = function () {
	return Promise.resolve({
		chatToken: hubspot.chatToken,
		userId: hubspot.chatToken !== '' ? hubspot.authUser.userId : '',
		tokenExpiresAt: hubspot.tokenExpiresAt,
	});
};

hubspot._fromStorageData = function (data) {
	if (data) {
		if (data.chatToken != '' && data.tokenExpiresAt > Date.now()) {
			if (data.userId == hubspot.authUser.userId) {
				hubspot.chatToken = data.chatToken;
				hubspot.tokenExpiresAt = data.tokenExpiresAt;
			}
		}
	}
	return Promise.resolve();
};

hubspot.setChatToken = (token) => {
	hubspot.chatToken = token;
	hubspot.tokenExpiresAt = Date.now() + 10 * 60 * 60 * 1000; //10 hours
	hubspot.global.storageHandler.save(hubspot);
};

hubspot.clearChatToken = () => {
	hubspot.chatToken = '';
	hubspot.tokenExpiresAt = 0;
	hubspot.global.storageHandler.save(hubspot);
};

hubspot.getChatToken = () => {
	return hubspot.chatToken;
};

hubspot.hasChatToken = () => {
	return hubspot.chatToken !== '' && hubspot.tokenExpiresAt > Date.now();
};

hubspot.boot = function () {
	if (!hubspot.isEnabled()) return;
	if (!window.HubSpotConversations) {
		system.log('HubSpotConversations is not available');
	}
	if (hubspot.hasChatToken()) {
		hubspot._initChat();
	} else {
		hubspot.loadChatToken();
	}
};

hubspot.loadChatToken = () => {
	hubspot.global
		.getDataSource('users')
		.call(hubspot.authUser.userId, 'createHubspotVisitorToken')
		.then((data) => {
			if (data.token) {
				hubspot.setChatToken(data.token);
				hubspot._initChat();
			}
		})
		.catch((err) => {
			system.log('Error creating HubSpot visitor token', err);
		});
};

const onConversationsAPIReady = () => {
	if (window.HubSpotConversations.widget) {
		window.HubSpotConversations.widget.load();
	} else {
		system.log('HubSpotConversations.widget is not available');
	}
};

hubspot._initChat = () => {
	if (!hubspot.hasChatToken()) return;
	window.hsConversationsSettings = {
		identificationEmail: hubspot.authUser.email,
		identificationToken: hubspot.getChatToken(),
		loadImmediately: true,
	};

	hubspot.addTrackingCode();

	/*
		The API is housed in the window.HubSpotConversations object, which provides access to all available methods.
		The object is created by the HubSpot tracking code, but may not be available immediately on page load. 
		To defer accessing the API until it's initialized, you can use the window.hsConversationsOnReady helper.

		https://developers.hubspot.com/docs/reference/api/conversations/chat-widget-sdk#initializing
	*/
	if (window.HubSpotConversations) {
		onConversationsAPIReady();
	} else {
		window.hsConversationsOnReady = [onConversationsAPIReady];
	}
};

hubspot.shutdown = function () {
	if (window.HubSpotConversations) {
		window.HubSpotConversations;
		if (window.HubSpotConversations.widget) {
			window.HubSpotConversations.clear();
			window.HubSpotConversations.widget.remove();
		}
		window.hsConversationsOnReady = [onConversationsAPIReady];
	}
};

hubspot.logout = function () {
	hubspot.clearChatToken();
	if (window.HubSpotConversations) {
		window.HubSpotConversations.clear({ resetWidget: true });
	}
};

hubspot.trackEvent = (eventName, properties = {}) => {
	if (window._hsq) {
		window._hsq.push(['trackEvent', { id: eventName, properties }]);
	}
};

hubspot.trackPageView = () => {
	if (window._hsq) {
		window._hsq.push(['trackPageView']);
	}
};

export default hubspot;
